const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Wybierz jeden z naszych atrakcyjnych pakietów!',
    },
};

export default translations;
